import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
    @Input() prevUrl = '/';

    @Input() progress = 0;

    public questionsAmount = 5;

    constructor(private navController: NavController) { }

    redirectBack() {
    	return this.navController.navigateBack([this.prevUrl]);
    }
}
